import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-announcements',
    templateUrl: './custom-announcements.component.html',
    styleUrls: ['./custom-announcements.component.scss'],
    standalone: false
})
export class CustomAnnouncementsComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
} 